"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const mui_dialog_confirmation_1 = require("@framework/mui-dialog-confirmation");
const mui_page_layout_1 = require("@framework/mui-page-layout");
const mui_form_1 = require("@framework/mui-form");
const react_hooks_1 = require("@framework/react-hooks");
const FormDialog = props => {
    const { children, disabled, onCancel, onConfirm, initialValues, validationSchema, maxWidth = "lg", testId, showPrompt = true, showDebug, ...rest } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { id } = (0, react_router_1.useParams)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const [touchedFields, setTouchedFields] = (0, react_1.useState)({});
    const [values, setValues] = (0, react_1.useState)({});
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, react_1.useState)(disabled);
    const innerRef = (0, react_1.useRef)(null);
    const onFormStateChange = async (form) => {
        const { formState: { isValid, touchedFields: formTouchedFields }, getValues, } = form;
        const values = getValues();
        setValues(values);
        setIsValid(isValid);
        setTouchedFields(formTouchedFields);
        return Promise.resolve();
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (innerRef && innerRef.current) {
            setIsLoading(true);
            innerRef.current.dispatchEvent(new Event("submit", { bubbles: false, cancelable: true }));
            setIsLoading(false);
        }
        return Promise.resolve();
    };
    const handleCancel = (0, react_1.useCallback)(() => {
        if (showPrompt && Object.keys(touchedFields).length) {
            if (window.confirm(formatMessage({ id: "form.hints.prompt" }))) {
                onCancel();
            }
        }
        else {
            onCancel();
        }
    }, [showPrompt, touchedFields]);
    (0, react_hooks_1.useDeepCompareEffect)(() => {
        if (disabled ?? ((id && Object.keys(touchedFields).length === 0) || !isValid)) {
            setIsSubmitDisabled(true);
        }
        return () => {
            setIsSubmitDisabled(false);
        };
    }, [{ disabled, id, isValid }, touchedFields, values]);
    return ((0, jsx_runtime_1.jsx)(mui_dialog_confirmation_1.ConfirmationDialog, { onConfirm: handleSubmit, maxWidth: maxWidth, disabled: isSubmitDisabled, "data-testid": "DialogForm", onCancel: handleCancel, ...rest, children: (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(mui_form_1.FormWrapper, { onSubmit: onConfirm, onFormStateChange: onFormStateChange, validationSchema: validationSchema, initialValues: initialValues, innerRef: innerRef, showButtons: false, showPrompt: false, showDebug: showDebug, testId: testId, children: children }) }) }));
};
exports.FormDialog = FormDialog;
//# sourceMappingURL=index.js.map